// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2DEeN","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__oEaUS"};